<template>
  <div class="notes-details-container">
    <div class="notes-heading">
      <div class="notes-name-container">
        <span class="notes-name">{{notesDetail.createdBy}}</span>
        <mds-tag class="notes-action">{{notesDetail.reviewAction}}</mds-tag>
      </div>
      <div class="notes-status-container">
        <span class="notes-status-details">
          <span class="notes-status-title">Review Status:</span>
          <span class="notes-status-value">
            <ReviewStatusIcons :status="[notesDetail.status]" :fullLength="true" />
          </span>
        </span>
        <span class="notes-date">{{formatDate}}</span>
      </div>
    </div>
    <p class="notes-description">
      {{notesDetail.notes}}
    </p>
  </div>
</template>

<script>
import { MdsTag } from '@mds/tag';
import { format } from 'date-fns';
import ReviewStatusIcons from '@/components/atoms/ReviewStatusIcons';

export default {
  name: 'fund-review-notes-details',
  components: {
    MdsTag,
    ReviewStatusIcons,
  },
  props: {
    notesDetail: {
      required: true,
      type: Object,
    },
  },
  computed: {
    formatDate() {
      return format(new Date(this.notesDetail.createdDate), 'MMM DD, YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.notes-details-container {
  margin-top: $mds-space-3-x;
  padding: $mds-space-3-x;
  border: 1px solid $mds-color-neutral-80;
  border-radius: $mds-space-1-x;
   @include mds-body-text-m();
  .notes-heading {
    .notes-name-container {
      display: flex;
      justify-content: space-between;
      margin-bottom: $mds-space-2-x;
      .notes-name {
        @include mds-body-text-m($bold: true);
      }
    }
    .notes-status-container {
      margin-bottom: $mds-space-2-x;
      .notes-status-details {
        margin-right: $mds-space-2-x;
        .notes-status-title {
          margin-right: $mds-space-half-x;
          @include mds-body-text-m($bold: true);
        }
        .notes-status-value {
          display: inline-block;
          vertical-align: text-bottom;
        }
      }
    }
  }
  .notes-description {
    margin: 0;
  }
}
</style>
